import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'
import RangeSelector from 'scoreboard/components/calendar-range-selector'
import filterOperators from 'scoreboard/reports/common/filter/filter-operators'
import template from './trend-filter.hbs'
import PeriodRangeDateFilter from './period-range-date-filter'

var TrendFilter = Backbone.View.extend({

	//this.data is a TrendFilter which is a java POJO

	initialize: function(options) {
		this.options = options
		this.data = _.cloneDeep(options.data)
		this.periodRangeDateFilter = new PeriodRangeDateFilter(options)
	},

	render: function() {
		var content = $(template())

		//populate the operator dropdown
		filterOperators.populate(content.find('select.trend'), 'trend',
			this.data.operator)

		this.$el.html(content)

		this.periodRangeDateFilter.setElement(this.$('.applies-to-container')).render()

		return this
	},

	//returns the data captured by this filter
	gather: function() {
		this.data = this.periodRangeDateFilter.gather()
		this.data.operator = this.$('select.trend').val()
		return this.data
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap(this.periodRangeDateFilter, 'remove')
	}

})

export default TrendFilter

TrendFilter.__filename__ = 'reports/wizard/filter-meta/trend-filter.js'
